function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.82731 13.6411L9.82732 13.6411C10.8275 14.636 11.4877 15.8596 11.741 17.173H18.9699C19.2185 15.8572 19.8687 14.6428 20.8573 13.6698L20.8573 13.6698C22.2768 12.273 23.0552 10.4307 23.0552 8.47974C23.0552 6.48208 22.2449 4.60869 20.7667 3.20146L20.7666 3.20145C19.2884 1.79414 17.3299 1.03369 15.2456 1.06137L9.82731 13.6411ZM9.82731 13.6411C8.40942 12.2307 7.6414 10.3756 7.65884 8.41473M9.82731 13.6411L15.2455 1.06138C13.2278 1.08893 11.3302 1.87005 9.89941 3.25946C8.46906 4.64841 7.67609 6.47872 7.65884 8.41473M7.65884 8.41473L7.25885 8.41116L7.65884 8.41473Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8575 19.2308H18.8559V20.1998H11.8575V19.2308Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.344 24.9045C13.6629 24.9045 12.2698 23.7623 11.9269 22.2608H18.7611C18.4182 23.7623 17.025 24.9045 15.344 24.9045Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.4 7.9498H4.1593V8.88738H0.4V7.9498Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.13034 15.2362L5.38 13.4246L5.86925 14.2428L2.61959 16.0543L2.13034 15.2362Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7804 14.3495L25.2696 13.5314L28.5193 15.3429L28.03 16.1611L24.7804 14.3495Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5547 8.07188H30.314V9.00945H26.5547V8.07188Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8435 2.7164L28.0931 0.904854L28.5824 1.723L25.3327 3.53456L24.8435 2.7164Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M2.19394 1.61685L2.68318 0.798697L5.93279 2.61022L5.44355 3.42837L2.19394 1.61685Z",
  stroke: "#394167",
  strokeWidth: 0.8
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 9.26074C9.15622 9.26074 9 8.64294 9 8.27299C9.00414 4.57531 11.7886 1.94727 15.2247 1.94287C15.5685 1.94287 15.8472 2.24433 15.8472 2.24433C16.191 2.24433 16.0938 2.24433 15.8472 2.24433C13.097 2.24433 10 5.80114 10 8.76074C9.75502 9.44698 9.84378 9.26074 9.5 9.26074Z",
  fill: "#F2F2F2"
});

function SvgActivitiesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesIcon);
export default __webpack_public_path__ + "static/media/ActivitiesIcon.019d1784.svg";
export { ForwardRef as ReactComponent };